// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeMangoApi = class EdgeMangoApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param mangoCardDetailsRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async cardDetailsGetCardDetails(mangoCardDetailsRequest, xProgramId) {
        const _url_ = '/edge/mango/v1/cardDetails/getCardDetails';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'mangoCardDetailsRequest' is not null or undefined
        if (mangoCardDetailsRequest === null || mangoCardDetailsRequest === undefined) {
            throw new Error('Required parameter mangoCardDetailsRequest was null or undefined when calling cardDetailsGetCardDetails.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(mangoCardDetailsRequest, "MangoCardDetailsRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param activationCode
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubGetPatientAccountSummary(activationCode, xProgramId) {
        const _url_ = '/edge/mango/v1/hub/getPatientAccountSummary/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubGetPatientAccountSummary.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubGetPatientAccountSummary");
        }
        return response;
    }
    /**
     *
     * @param activationCode
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubGetPatientWelcomeSummary(activationCode, xProgramId) {
        const _url_ = '/edge/mango/v1/hub/getPatientWelcomeSummary/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubGetPatientWelcomeSummary.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubGetPatientWelcomeSummaryResponse");
        }
        return response;
    }
    /**
     *
     * @param activationCode
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubGivePatientConsent(activationCode, xProgramId) {
        const _url_ = '/edge/mango/v1/hub/givePatientConsent/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubGivePatientConsent.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubGivePatientConsentResponse");
        }
        return response;
    }
    /**
     *
     * @param activationCode
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubRevokePatientConsent(activationCode, xProgramId) {
        const _url_ = '/edge/mango/v1/hub/revokePatientConsent/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubRevokePatientConsent.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubRevokePatientConsentResponse");
        }
        return response;
    }
    /**
     *
     * @param mangoHubVerifyPatientRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async hubVerifyPatient(mangoHubVerifyPatientRequest, xProgramId) {
        const _url_ = '/edge/mango/v1/hub/verifyPatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'mangoHubVerifyPatientRequest' is not null or undefined
        if (mangoHubVerifyPatientRequest === null || mangoHubVerifyPatientRequest === undefined) {
            throw new Error('Required parameter mangoHubVerifyPatientRequest was null or undefined when calling hubVerifyPatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(mangoHubVerifyPatientRequest, "MangoHubVerifyPatientRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubVerifyPatientResponse");
        }
        return response;
    }
};
EdgeMangoApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeMangoApi);
export { EdgeMangoApi };
//# sourceMappingURL=edgeMangoApi.js.map